type UploadResultLike = { successful?: ReadonlyArray<{ uploadURL?: string | undefined }> | undefined } | undefined;

/**
 * Returns the upload URL of the first successfully uploaded file. A result with no successful
 * files means the upload failed, so this throws rather than reporting success without a file.
 */
export function getFirstUploadUrl(result: UploadResultLike): string | undefined {
	const [first] = result?.successful ?? [];
	if (!first) throw new Error('No successful upload');
	return first.uploadURL;
}
